import { render, staticRenderFns } from "./MessageLogs.vue?vue&type=template&id=4450b02d&scoped=true"
import script from "./MessageLogs.vue?vue&type=script&lang=js"
export * from "./MessageLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4450b02d",
  null
  
)

export default component.exports